import { i18n } from 'i18next';
import { Table } from 'pdfmake/interfaces';
import { InstallationConfig } from '../types/onsiteConfig';
import { Registration } from '../types/registrationTypes';
import { tableRow } from './tableRow';

export const customerAndLocationHeader = (t: i18n['t']): Table['body'] => {
  return [
    [
      {
        style: 'tableHeader',
        margin: [10, 0, 0, 0],
        text: t('registrations.general.owner')
      },
      {},
      {
        style: 'tableHeader',
        margin: [0, 0, 0, 0],
        text: t('registrations.general.location')
      }
    ]
  ];
};

export const customerAndLocationData = (t: i18n['t'], registration: Registration, installationConfig: InstallationConfig): Table['body'] => {
  const MISSING_DATA_STRING = 'MISSING DATA';

  const configuratedCustomerTypes = installationConfig?.customerTypes ?? [];
  const configuratedInsurance = installationConfig?.insuranceTypes ?? [];

  const getInsuranceDescription = (registration: Registration) =>
    configuratedInsurance.find((insurance) => insurance.code === registration.customer?.insuranceType);

  const getInsuranceCustomerType = (registration: Registration) =>
    configuratedCustomerTypes.find((insurance) => insurance.code === registration.customer?.type);

  return [
    [
      {
        style: 'tableBody',
        margin: [10, 5, 10, 10],
        columns: [
          [
            tableRow(
              t('registrations.general.firstName'),
              registration.customer?.firstName === MISSING_DATA_STRING ? '-' : registration.customer?.firstName ?? ''
            ),
            tableRow(
              t('registrations.general.lastName'),
              registration.customer?.lastName === MISSING_DATA_STRING ? '-' : registration.customer?.lastName ?? ''
            ),
            tableRow(
              t('registrations.general.address'),
              registration.customer?.address === MISSING_DATA_STRING ? '-' : registration.customer?.address ?? ''
            ),
            tableRow(
              t('registrations.general.zipCode'),
              registration.customer?.zipCode === MISSING_DATA_STRING ? '-' : registration.customer?.zipCode ?? ''
            ),
            tableRow(t('registrations.general.city'), registration.customer?.city === MISSING_DATA_STRING ? '-' : registration.customer?.city ?? ''),
            tableRow(
              t('registrations.general.country'),
              t(registration.customer?.country === MISSING_DATA_STRING ? '-' : registration.customer?.country ?? '')
            ),
            tableRow(
              t('registrations.general.phone'),
              registration.customer?.phone === MISSING_DATA_STRING ? '-' : registration.customer?.phone ?? ''
            ),
            tableRow(
              t('registrations.general.email'),
              registration.customer?.email === MISSING_DATA_STRING ? '-' : registration.customer?.email ?? ''
            ),
            tableRow(
              t('registrations.general.customerType'),
              t(`registrations.insuranceDescriptions.${getInsuranceCustomerType(registration)?.displayName}`)
            ),
            tableRow(
              t('registrations.general.insurance'),
              t(
                registration.customer?.insuranceType
                  ? `registrations.insuranceDescriptions.${getInsuranceDescription(registration)?.displayName}`
                  : ''
              )
            )
          ]
        ]
      },
      {},
      {
        style: 'tableBody',
        margin: [0, 5, 10, 10],
        columns: [
          [
            tableRow(
              t('registrations.general.propertyType'),
              t(registration.location?.propertyType === MISSING_DATA_STRING ? '-' : registration.location?.propertyType ?? '')
            ),
            tableRow(
              t('registrations.general.installationDate'),
              registration.location?.installationDate === MISSING_DATA_STRING ? '-' : registration.location?.installationDate ?? ''
            ),
            tableRow(
              t('registrations.general.address'),
              registration.location?.installationAddress === MISSING_DATA_STRING ? '-' : registration.location?.installationAddress ?? ''
            ),
            tableRow(
              t('registrations.general.zipCode'),
              registration.location?.zipCode === MISSING_DATA_STRING ? '-' : registration.location?.zipCode ?? ''
            ),
            tableRow(t('registrations.general.city'), registration.location?.city === MISSING_DATA_STRING ? '-' : registration.location?.city ?? ''),
            tableRow(
              t('registrations.general.country'),
              t(registration.location?.country === MISSING_DATA_STRING ? '-' : registration.location?.country ?? '')
            )
          ]
        ]
      }
    ]
  ];
};
